module.exports = __webpack_public_path__ + "img/login_bg.7cfbcf58.png";